import { Creative } from '../creative'
import { ISODateString } from '../misc'
import { Nullable } from 'models/helpers'

/** Where the search for a creative for an express order stands */
export enum ExpressDispatchClientState {
  /** Still waiting for a creative before the deadline */
  SEARCHING = 'SEARCHING',
  /** A creative accepted */
  CREATIVE_FOUND = 'CREATIVE_FOUND',
  /** The deadline passed with nobody accepting */
  NOBODY_FOUND = 'NOBODY_FOUND',
  /** Ops arrange the creative, e.g. after a reschedule */
  HANDLED_BY_TEAM = 'HANDLED_BY_TEAM',
  /** The order, or every part of it that needs a creative, was cancelled */
  CANCELLED = 'CANCELLED',
}

/** Which attempt of the express dispatch the client state refers to */
export enum ExpressDispatchAttempt {
  /** The creative the client picked */
  PICKED_CREATIVE = 'PICKED_CREATIVE',
  /** Every available creative at once */
  BROADCAST = 'BROADCAST',
}

/** State of one broadcast of an express order */
export enum BroadcastState {
  /** Creatives can still accept */
  OPEN = 'OPEN',
  /** The winner took every creative line */
  ACCEPTED = 'ACCEPTED',
  /** The deadline passed with nobody accepting */
  EXPIRED = 'EXPIRED',
  /** Stopped early by a cancel, a reschedule or ops */
  REVOKED = 'REVOKED',
}

/** What the client's waiting page shows for an express order */
export interface ExpressDispatchClientDTO {
  state: ExpressDispatchClientState
  /** Null once ops handle the order, and when no attempt was made */
  attempt: Nullable<ExpressDispatchAttempt>
  /** When the wait ends; count down against serverTime, not the device clock */
  expiresAt: ISODateString
  /** The server's clock when the order was read */
  serverTime: ISODateString
}

/** A broadcast's invites by state, and their pushes by delivery */
export interface BroadcastInviteCountsDTO {
  /** Every creative asked */
  total: number
  /** Still able to accept */
  waiting: number
  won: number
  /** Still waiting when another creative won */
  lost: number
  /** Still waiting when the deadline passed */
  expired: number
  /** Still waiting when the broadcast was revoked */
  revoked: number
  /** Opted out of the order */
  dismissed: number
  pushSent: number
  pushFailed: number
  /** Pushes not attempted yet */
  pushPending: number
}

/** One broadcast of an express order to every available creative at once */
export interface BroadcastAdminDTO {
  id: string
  /** Which broadcast of the order this is, from 1 */
  attemptNumber: number
  state: BroadcastState
  /** OPEN past its deadline; the sweep expires it within a minute */
  overdue: boolean
  /** OPEN and before its deadline */
  revocable: boolean
  openedAt: ISODateString
  expiresAt: ISODateString
  /** Null while OPEN */
  closedAt: Nullable<ISODateString>
  invites: BroadcastInviteCountsDTO
  /** Null unless ACCEPTED */
  winner: Nullable<Creative>
  acceptedAt: Nullable<ISODateString>
}
